import {ContentBox} from '@hconnect/common/components'
import {getHighlightedTitle} from '@hconnect/common/utils'
import CloseIcon from '@mui/icons-material/Close'
import {Typography, IconButton, Stack} from '@mui/material'
import React from 'react'

import {mapToAppName} from '../../mappers'
import {HProduceTask} from '../../types'

import {SourceAppInfo} from './SourceAppInfo'

export type Props = {
  item: HProduceTask
  onClose: (original?: HProduceTask, editVersion?: HProduceTask) => void
  freeSearchText?: string
  enableSourceAppInfo?: boolean
  timezone: string
  metaAnnotationSlot: React.ReactNode
  children?: React.ReactNode
}

const getTaskTitle = (title: string, freeSearchText?: string) =>
  freeSearchText ? getHighlightedTitle(title, freeSearchText) : title

export const TaskDetailsCard: React.FC<Props> = (props) => {
  const {
    item,
    onClose,
    freeSearchText,
    enableSourceAppInfo = true,
    metaAnnotationSlot,
    children
  } = props

  return (
    <ContentBox
      data-test-id="task-details"
      mode="max100PercentOfParentHeight"
      bodyWithPadding
      {...(enableSourceAppInfo && {
        aboveTitle: (
          <SourceAppInfo
            app={mapToAppName(item.source)}
            externalId={item.externalId}
            plantId={item.plantId}
          />
        )
      })}
      title={
        <Typography
          component="span"
          variant="h2"
          sx={{textTransform: 'none'}}
          data-test-id="task-details-title"
          display="flex"
          alignItems="center"
        >
          {getTaskTitle(item.title, freeSearchText)}
        </Typography>
      }
      afterTitle={
        <IconButton onClick={() => onClose()} data-test-id="task-details-close">
          <CloseIcon color="primary" />
        </IconButton>
      }
      headerSx={{paddingBottom: 0}}
    >
      <Stack spacing={2} useFlexGap>
        <Stack>{metaAnnotationSlot}</Stack>
        {children}
      </Stack>
    </ContentBox>
  )
}
